<template>
  <gmap-map :center="center" :zoom="13" style="width:100%;  height: 300px;">
    <gmap-marker
      :key="index"
      v-for="(m, index) in markers"
      :position="m.position"
      @click="center=m.position"
    ></gmap-marker>
  </gmap-map>
</template>

<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      center: {
        lat: 14.6241,
        lng: 121.0316
      },
      markers: [
        {
          position: {
            lat: 14.6241,
            lng: 121.0316
          }
        }
      ]
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/GoogleMap.vue